import React from "react";
import {
  ShoppingBag, Briefcase, Phone, Stethoscope, Home, UtensilsCrossed, Landmark, Plane,
  Building2, Car, GraduationCap, MessageCircle, ShoppingCart, Pill, TrainFront, Building,
  Users, HeartPulse, KeyRound, UserCheck, Sparkles,
  Coffee, Croissant, IceCream, ShoppingBasket, Store, Pizza, Beer, Wine,
} from "lucide-react";

const ICONS = {
  ShoppingBag, Briefcase, Phone, Stethoscope, Home, UtensilsCrossed, Landmark, Plane,
  Building2, Car, GraduationCap, MessageCircle, ShoppingCart, Pill, TrainFront, Building,
  Users, HeartPulse, KeyRound, UserCheck, Sparkles,
  Coffee, Croissant, IceCream, ShoppingBasket, Store, Pizza, Beer, Wine,
};

// Individual accent colour per situation (hex) for the dark theme icon chips.
const ACCENT = {
  shopping: "#a855f7", work: "#4f6bff", phone: "#22d3ee", doctor: "#ec4899",
  apartment: "#34d399", restaurant: "#f59e0b", bank: "#818cf8", travel: "#38bdf8",
  government: "#94a3b8", car: "#fb923c", school: "#2dd4bf", smalltalk: "#e879f9",
  migros: "#f87171", pharmacy: "#f472b6", sbb: "#60a5fa", gemeinde: "#a78bfa",
  rav: "#5eead4", krankenkasse: "#fb7185", verwaltung: "#c084fc", job_interview: "#7dd3fc",
  fr_cafe: "#f59e0b", fr_boulangerie: "#fbbf24", fr_marche: "#34d399", fr_pharmacie: "#f472b6", fr_prefecture: "#94a3b8",
  it_bar: "#f59e0b", it_trattoria: "#fb7185", it_mercato: "#34d399", it_gelateria: "#f472b6", it_questura: "#94a3b8",
  es_tapas: "#f59e0b", es_mercado: "#34d399", es_cafeteria: "#fbbf24", es_farmacia: "#f472b6", es_extranjeria: "#94a3b8",
  en_pub: "#f59e0b", en_gp: "#ec4899", en_coffee: "#fbbf24", en_chemist: "#f472b6", en_council: "#94a3b8",
};
const CAT_ACCENT = { "Daily Life": "#a855f7", Work: "#4f6bff", Health: "#ec4899", Travel: "#38bdf8", Switzerland: "#f87171" };

export function accentFor(key, category) {
  return ACCENT[key] || CAT_ACCENT[category] || "#2563eb";
}

export default function SituationIcon({ name, className = "", size = 24 }) {
  const Icon = ICONS[name] || MessageCircle;
  return <Icon className={className} size={size} strokeWidth={2.1} />;
}
